import React from "react"
import PropTypes from "prop-types"

export default class ThinkhrLayout extends React.Component {

  static propTypes = {
    errSelectors: PropTypes.object.isRequired,
    errActions: PropTypes.object.isRequired,
    specActions: PropTypes.object.isRequired,
    specSelectors: PropTypes.object.isRequired,
    oas3Selectors: PropTypes.object.isRequired,
    oas3Actions: PropTypes.object.isRequired,
    layoutSelectors: PropTypes.object.isRequired,
    layoutActions: PropTypes.object.isRequired,
    getComponent: PropTypes.func.isRequired
  }

  renderBasicsOfListSection(isInternal) {
    if (!isInternal) {
        return (
            <div>
                <h3 id="the_basics_of_list">The Basics of LIST</h3>
                <p className="basics-list-def">The LIST API supports additional features such as pagination, filters, search and sorting as detailed below:
                </p>
                <ul className="content-list">
                  <li>
                    <h4>Pagination:</h4>
                    <p>Pagination is supported using “limit” and “offset” query parameters as follows:</p>
                    <ul className="content-list">
                      <li>
                        <strong>- Limit: </strong>
                        <span>Specifies the maximum number of records which shall be returned. [default = 50]</span>
                      </li>
                      <li>
                        <strong>- Offset: </strong>
                        <span>Specifies the number of records to be skipped before returning results. [default = 0]</span>
                      </li>
                    </ul>
                    <br/><strong>e.g. </strong>
                    <span className="code-text">/v2/companies?limit=10&offset=20 </span>
                    <span>will list companies from 21 to 30.</span>
                  </li>
                  <li>
                    <h4>Sorting:</h4>
                    <p>Sorting is supported using attribute name with plus/minus symbols where + stands for ASC and — for DESC sorting order. Sorting can be performed on any attribute seen in the response. </p>
                    <strong>e.g. </strong>
                    <span className="code-text">/v2/companies?sort=-companyName </span>
                    <span>returns result sorted on “companyName”, attribute DESC [Z-A]. </span>
                  </li>
                  <li>
                    <h4>Search:</h4>
                    <p>Provides a generic search for given search string in pre-defined attributes. This search is supported by using query parameter “searchSpec.” This search is case insensitive. </p>
                    <strong>e.g. </strong>
                    <span className="code-text">/v2/companies?searchSpec=Corp </span>
                    <span> searches all of the pre-defined attributes of a Company for the string "corp" and returns all those which match. </span>
                  </li>
                  <li>
                    <h4 id="filters" className="filter-parameters">Filters:</h4>
                    <p>Filters records using free form parameters. Result can be filtered on any attribute by providing the attribute name and the requested value. If the attribute is a string, an exact match will be attempted and if there are no results then a partial match will be attempted.</p>
                    <strong>e.g. </strong>
                    <span className="code-text">/v2/companies?companyName=Corp </span>
                    <span>returns company records that exactly match the string “corp”, followed by companies with “corp” appearing anywhere in the companyName attribute.
                    </span>

                    <p>The "modifiedOn" attribute is a special case and supports additional operators defined below:</p>
                    <ul className="content-list">
                      <li><strong> - [lt]: </strong><span>less than </span></li>
                      <li><strong> - [lte]: </strong><span>less than equals to </span></li>
                      <li><strong> - [gt]: </strong><span>greater than </span></li>
                      <li><strong> - [gte]: </strong><span>greater than equals to </span></li>
                      <li><strong> - [eq]: </strong><span>equals to </span></li>
                    </ul>
                    <p>Filter on “modifiedOn” attribute accepts a date value in ISO 8601 format yyyy-MM-dd'T'HH:mm:ss+|-hh:mm</p>
                    <p>
                      <strong>Note: </strong>
                      <small><i>The modifiedOn attribute is currently only available for Companies and Users.</i></small>
                    </p>
                    <strong>e.g. </strong>
                    <span className="code-text">v2/companies?modifiedOn[lt]=2018-07-10T18:21:23+05:30 </span>
                    <span>returns all companies updated before July 10, 2018 at 6:21:23 PM India Standard Time.</span>
                    <p><strong>All of these features may be used in combination.</strong></p>
                    <strong>e.g. </strong>
                    <span className="code-text">/v2/companies?limit=50&companyName=corp&sort=-companyName </span>
                    <span>returns up to 50 companies sorted by companyName in descending (Z-A) order which contain "corp" in the companyName attribute.</span>
                  </li>
                </ul>
            </div>
        );
	}
	return null;
  }

  renderComingSoonSection(isInternal) {
    if (!isInternal) {
        /*return (
            <div>
                <h3>Coming Soon!</h3>
                <ul className="content-list">
                  <li>- Webhooks</li>
                  <li>- Call Summary</li>
                  <li>- Call History</li>
                  <li>- Continued Conversation</li>
                </ul>
            </div>
        );*/
        return null;
	}
	return null;
  }

  render() {
    let {
      specSelectors,
      specActions,
      getComponent,
      layoutSelectors,
      oas3Selectors,
      oas3Actions,
      getConfigs,
    } = this.props

    const {
      isInternal
    } = getConfigs()

    
    let url = specSelectors.url()
    let basePath = specSelectors.basePath()
    let host = specSelectors.host()
    let securityDefinitions = specSelectors.securityDefinitions()
    let externalDocs = specSelectors.externalDocs()
    // In the render method, after getting components (around line 131)  
    let MineralEmbedded = getComponent("MineralEmbedded", true)  

  
    let Operations = getComponent("operations", true)
    let Models = getComponent("Models", true)
    let AuthorizeBtn = getComponent("authorizeBtn", true)
    let Row = getComponent("Row")
    let Col = getComponent("Col")

    

    //custom components
    let Sidebar = getComponent("Sidebar", true)

    let isLoading = specSelectors.loadingStatus() === "loading"
    let isFailed = specSelectors.loadingStatus() === "failed"

    let inputStyle = {}
    if(isFailed) inputStyle.color = "red"
    if(isLoading) inputStyle.color = "#aaa"

    const isSpecEmpty = !specSelectors.specStr()

    if(isSpecEmpty) {
      return <h4>No spec provided.</h4>
    }

    return (

      <div className="swagger-ui thr-ui bottom-padding">
        <Row>
          <Col mobile={3} desktop={3}>
            <Sidebar />
          </Col>
          <Col mobile={9} desktop={9} className="thr-content">
            <Row>
              <Col>
                <h1>Getting Started</h1>
                <h2 id="welcome">Welcome to Mineral Developer&#39;s Hub!</h2>
                <p>Using Mineral APIs, you can quickly, easily and securely access the Mineral platform and its features.   Detailed information on all Mineral resources and methods is provided below.</p>
                <img className="apiModel" src="apiModel.png"/>
                <p className="content-list-heading">The Mineral API platform uses the following standards:</p>
                <ul className="content-list">
                  <li>- <a href="https://en.wikipedia.org/wiki/Representational_state_transfer">REST</a>ful resource-oriented URLs.</li>
                  <li>- <a href="https://en.wikipedia.org/wiki/OAuth#OAuth_2.0">OAuth 2.0</a> authentication to enable both read and write access to users&#39; public and private data.</li>
                  <li>- <a href="https://en.wikipedia.org/wiki/List_of_HTTP_status_codes">HTTP response codes</a> to indicate API errors and successes.</li>
                  <li>- <a href="http://en.wikipedia.org/wiki/JSON">JSON</a>-formatted responses for all API requests.</li>
                </ul>

                <p>To try any of the APIs described here just follow these steps:</p>
                <ol className="content-list">
                  <li>1. Click the &quot;Authorize&quot; button below.</li>
                  <li>2. Enter your Mineral username and password.</li>
                  <li>3. Enter your client_id and client_secret (Available from your Account Manager.)</li>
                  <li>4. Click &quot;Authorize&quot;.</li>
                  <li>5. Click the X in the upper right corner next to &quot;Available authorizations&quot; to close the window.  You may now click on any &quot;Try It Out&quot; button, provide any required information and click &quot;Execute&quot; to submit a request.  A sample curl command will be provided along with the response body and headers.</li>
                </ol>
                <p>You are now ready to go.  Click the 'Try It Out' button next to the API you want to test, provide any required information, and then click 'Execute' to submit a request.  A sample Curl command will be provided along with the response body and headers.</p>

                {this.renderComingSoonSection(isInternal)}
                <p>For more information on authorization tokens, x-api-key, and authentication details, refer to the <a href="javascript:void(0);" onClick={() => { var el = document.getElementById('security'); if (el) { el.scrollIntoView({ behavior: 'smooth' }); } }} style={{ color: '#4990e2', cursor: 'pointer', textDecoration: 'underline' }}>Security</a> section below.</p>

                <div style={{ float: 'left' }}>< AuthorizeBtn /></div>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>This document provides information to developers on how to integrate with the Mineral API.</p>
                <h2 id="security">Security</h2>
                <p>Mineral APIs use the <a href="http://tools.ietf.org/html/rfc6749">OAuth 2.0 protocol</a> for authentication and authorization, enforced by an API Gateway.</p>
                <p>Once you have obtained OAuth 2.0 client credentials, your client [REDACTED SECRET] requests an access token from the Mineral Authorization Server, extracts a token from the response, and sends the token along with your API key to the Mineral API you want to access via the API Gateway.</p>
                <p>All requests require an API key. If the <span className="code-text">x-api-key</span> header is missing or invalid, the request is rejected before reaching the authorization layer.</p>
                <p className="content-list-heading">If an access token has become invalid, API requests will receive a &quot;401 Unauthorized&quot; response. A token may become invalid for the following reasons:</p>
                <ul className="content-list">
                  <li>- The <span className="code-text">expires_at</span> date/time has passed</li>
                  <li>- The user has revoked the grant</li>
                  <li>- A new access token has been issued for this user, invalidating the existing one</li>
                </ul>
                <h4>How to request an access token</h4>
                <p>The client makes a request to the token endpoint, /v2/oauth/token, using the following parameters:</p>
                <ul className="content-list">
                  <li>- grant_type : Required. Must be set to &quot;password&quot;.</li>
                  <li>- username : Required. A Mineral platform username authorized to invoke REST APIs.</li>
                  <li>- password : Required. The associated Mineral platform password.</li>
                </ul>
                <p>The following request headers must also be set:</p>
                <ul className="content-list">
                  <li>- Authorization (e.g., &quot;Authorization: Basic &lt;Encoded Client Credentials&gt;&quot;)</li>
                  <li>- Content-Type (e.g., &quot;Content-Type: [REDACTED SECRET]/x-www-form-urlencoded&quot;)</li>
                  <li>- x-api-key (e.g., &quot;x-api-key: &lt;Your API Key&gt;&quot;)</li>
                </ul>
                <p>You will receive a response from the token endpoint similar to the following:</p>
                <p><span className="code-text">&#123;<br/>
                  &nbsp;&nbsp;&nbsp;"access_token": ".ofbzIiBoirSPnOxoUC2uxOo44c5CMn5j-h_Lyi2fG4E",<br/>
                  &nbsp;&nbsp;&nbsp;"token_type": "bearer",<br/>
                  &nbsp;&nbsp;&nbsp;"refresh_token": "iC4_PQQeFuvxjz736DBR-1q0X4R3fiH-f-9Pzmy19e4",<br/>
                  &nbsp;&nbsp;&nbsp;"expires_in": 3599,<br/>
                  &nbsp;&nbsp;&nbsp;"scope": "all"<br/>
                  &#125;</span></p>

                <h4>Usage of a refresh token</h4>
                <p>Token endpoint also returns a refresh token in addition to the access token. A Refresh Token is a special kind of token that can be used to obtain a new access token if the current one is expired. Refresh tokens expire in 30 days.</p>
                <p>To obtain a new access token, the client makes a request to the token endpoint, /v2/oauth/token, using the following parameters:</p>
                <ul className="content-list">
                  <li>- grant_type : REQUIRED.  Value MUST be set to "refresh_token".</li>
                  <li>- refresh_token : REQUIRED.  The value of the refresh token.</li>
                </ul>
                <p>In addition, the following request headers must be set:</p>
                <ul className="content-list">
                  <li>- Authorization  (e.g.  "Authorization: Basic &lt;Encoded client Credentials&gt;" .</li>
                </ul>
                <p>You will receive a response from the token endpoint similar to the one above for requesting a new token.</p>

                {this.renderBasicsOfListSection(isInternal)}

                <h3 id="Postman">Postman Collection</h3>
                <p>Download our Postman collection to streamline your integration process and get the most out of the Mineral's authentication services and APIs.</p>
                <div class="mt-5">
                  <a href= "https://cdn.trustmineral.com/developers-hub/Developers-Hub-Alpha-collection.json" download>
                    <button class="btn is-medium is-fullwidth is-primary" className="btn" >Postman Collection</button>
                  </a> &nbsp;
                  <a href= "https://cdn.trustmineral-staging.com/developers-hub/Developers-Hub-Alpha-environment-variable.json" download>
                    <button class="btn is-medium is-fullwidth is-primary" className="btn">Environment Variables</button>
                  </a>
                </div>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
 
                <h1>API</h1>
				<p>Sandbox and Production URLs are as follows:</p>
                <ul>
                  <li>Production: https://restapis.trustmineral.com/v2</li>
                  <li>Sandbox: https://restapis.alpha01.trustmineral-staging.com/v2</li>
                </ul>
				<p>Click the 'Try It Out' button next to the API you want to test, provide any required information, and then click 'Execute' to submit a request. A sample Curl command will be provided along with the response body and headers.</p>
                <Operations />
                <div id="mineral-embedded">  
                  <MineralEmbedded getComponent={getComponent} />  
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      )
  }
}



// WEBPACK FOOTER //
// ./src/core/components/layouts/thinkhr.jsx